export enum expectedAnswerType {
  none = "none",
  yes = "yes",
  no = "no",
  neutral = "neutral"
}
